import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { BsModalService } from "ngx-bootstrap/modal";
import { ModalCrearJornadaComponent } from "./modal-crear-jornada/modal-crear-jornada.component";
import { ModalEditarJornadaComponent } from './modal-editar-jornada/modal-editar-jornada.component';
import { ModalIniciarJornadaComponent } from './modal-iniciar-jornada/modal-iniciar-jornada.component';
import { ApiService } from "../services/api.service";
import { GetListaViajesResponseDTO } from "../../dtos/response/getListaViajes.response.dto";
import { GeneralResponseDTO } from "../../dtos/response/general.response.dto";
import { AppMessage } from "../app.message";
import { NgClass, NgForOf, NgIf } from "@angular/common";
import { NgSelectModule } from "@ng-select/ng-select";
import { ProgressbarModule } from "ngx-bootstrap/progressbar";
import { FormsModule } from "@angular/forms";
import { GetListaJorndasResponseDTO } from "../../dtos/response/getListaJornadas.response.dto";
import { InfiniteScrollDirective } from "ngx-infinite-scroll";
import { GetKPISgestionJornadaResponseDTO } from "../../dtos/response/getKPISgestionJornada.response.dto";
import { KpiDTO } from "../../dtos/kpi.dto";
import moment from "moment/moment";
import 'moment/locale/es';
import { debounceTime, distinctUntilChanged, Observable, skip, Subject, Subscription } from "rxjs";
import { BsDatepickerModule, BsLocaleService } from "ngx-bootstrap/datepicker";
moment.locale('es');

import { defineLocale, esLocale } from 'ngx-bootstrap/chronos';
import { SucursalService } from "../services/sucursal.service";
import { EventService } from "../services/event.service";
import { CambiarSucursalComponent } from "../modals/cambiar-sucursal/cambiar-sucursal.component";
import { JornadaService } from "../services/jornada.service";
import { JornadaDTO } from "../../dtos/jornada.dto";
import { ModalCambiarSucursalCbComponent } from "./modal-cambiar-sucursal-cb/modal-cambiar-sucursal-cb.component";
import { HttpErrorResponse } from "@angular/common/http";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { ModalCancelarJornadaComponent } from "./modal-cancelar-jornada/modal-cancelar-jornada.component";
import { EstadosService } from "../services/estados.service";
import { PdfDTO } from "../../dtos/pdf.dto";
import { ConfigMqttService } from "../services/configMqtt.service";
import {
  ModalDeshacerFinalizarJComponent
} from "../gestion-conductores/modal-deshacer-finalizar-j/modal-deshacer-finalizar-j.component";
import { ToastrService } from "ngx-toastr";
import { IMqttMessage } from "ngx-mqtt";
import { GetDetalleJornadaResponseDTO } from "../../dtos/response/getDetalleJornada.response.dto";
import { UserService } from "../services/user.service";
defineLocale('es-do', esLocale);



@Component({
  selector: 'app-gestion-jornada',
  standalone: true,
  imports: [
    NgIf,
    NgSelectModule,
    ProgressbarModule,
    FormsModule,
    InfiniteScrollDirective,
    NgForOf,
    BsDatepickerModule,
    NgClass,
    TooltipModule
  ],
  templateUrl: './gestion-jornada.component.html',
  styleUrl: './gestion-jornada.component.scss'
})
export class GestionJornadaComponent implements OnInit, OnDestroy {

  indicadores: boolean = true;
  filtroColap: boolean = false;
  loading: boolean = false;
  loadingKPI: boolean = false;

  public modoEstandar: boolean = true;
  public kpiSelected: KpiDTO;
  public listaJornadas: Array<JornadaDTO> = [];
  private pageSize: number = 200;
  private page: number = 0;
  private hasNext: boolean = false;
  public desactivarInfiniteScroll: boolean = true;
  public optionRecargas = [
    { label: 'Off', value: 0 },
    //    { label: '20 segundos', value: 20000 },
    //    { label: '1 minuto', value: 60000 },
    //    { label: '2 minutos', value: 120000 },
    //    { label: '5 minutos', value: 300000 },
    { label: '15 minutos', value: 900000 },
  ];
  public recarga = this.optionRecargas[1];
  public intervaloProgressBar: any;
  public contador: number = 0;
  public listaKPis: Array<KpiDTO> = [];
  public searchTxtConductor: string = '';
  private inputConductorValue: Subject<string> = new Subject<string>();
  private inputConductorObservable: Observable<string>;
  private subscriptionConductorSearch: Subscription;
  private sucursalesSub: Subscription;
  public searchDesde: Date = new Date();
  public searchHasta: Date = new Date();
  public cargaInicialDatePickerDesde = 0;
  public cargaInicialDatePickerHasta = 0;
  public sucursalesSelectedNombres: string = '';
  public sucursalesSelectedNombresLargos: string = '';
  public horaActual: string = "";
  private intervalReloj: any;
  public estado: Array<string> = [];//['ATRASADA','PLANIFICADA'];
  public ESTADOS_GESTION_JORNADA = EstadosService.ESTADOS_GESTION_JORNADA;
  public procesandoPdf: boolean = false;
  public listaUuidJornadasRecienCreadas: Array<string> = [];
  private listadoSuscripcionesJornadasMqtt: { [key: string]: Subscription } = {};


  constructor(private modalService: BsModalService, private apiService: ApiService, private bsLocaleService: BsLocaleService,
    private sucursalService: SucursalService, private eventService: EventService, private jornadaService: JornadaService,
    public estadosService: EstadosService, private configMqttService: ConfigMqttService,
    private toastr: ToastrService, private userService: UserService) {
    this.bsLocaleService.use('es-do');
    this.inputConductorObservable = this.inputConductorValue.pipe(
      debounceTime(600),
      distinctUntilChanged()
    );
    this.subscriptionConductorSearch = this.inputConductorObservable.subscribe(texto => {
      this.searchTxtConductor = texto;
      this.page = 0;
      this.getListaJornadas(true);
    });
  }

  objectKeys(obj) {
    return Object.keys(obj);
  }

  ngOnInit(): void {
    this.sucursalesSelectedNombres = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto();
    this.sucursalesSelectedNombresLargos = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto(true);
    this.initSuscripcionesEventos();
    this.initReloj();
    if (!this.sucursalService.getSucursalesSeleccionadas() || this.sucursalService.getSucursalesSeleccionadas().length == 0) {
      //alert('Debe seleccionar alguna sucursal');
      this.toastr.warning('Debe seleccionar alguna sucursal', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }
    this.initAllDatosWS();
    this.calcularTime();
  }

  getEstadosSeleccionados() {
    let arregloSelected: Array<string> = [];
    this.estado.forEach((estado) => {
      arregloSelected.push(this.ESTADOS_GESTION_JORNADA[estado]);
    });

    return arregloSelected.join(',');
  }

  reload() {
    this.calcularTime();
    this.initAllDatosWS();
  }

  initReloj() {
    this.horaActual = moment().format("HH:mm:ss");
    this.intervalReloj = setInterval(() => { this.horaActual = moment().format("HH:mm:ss"); }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.intervaloProgressBar);
    if (this.subscriptionConductorSearch)
      this.subscriptionConductorSearch.unsubscribe();
    this.sucursalesSub?.unsubscribe();
    this.unsubscribeMqtt();
  }

  initSuscripcionesEventos() {
    this.sucursalesSub = this.sucursalService.sucursales$.pipe(skip(1)).subscribe(() => {
      this.sucursalesSelectedNombres = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto();
      this.sucursalesSelectedNombresLargos = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto(true);
      this.initAllDatosWS();
    })

    this.eventService.subscribe('INICIAR_JORNADA_SUCCESS', () => {
      this.initAllDatosWS();
    })

    this.eventService.subscribe('CAMBIO_HORA_JORNADA_SUCCESS', () => {
      this.initAllDatosWS();
    })

    this.eventService.subscribe('CAMBIAR_SUCURSAL_JORNADA_SUCCESS', () => {
      this.initAllDatosWS();
    })

    this.eventService.subscribe('CREAR_JORNADA_SUCCESS', () => {
      this.listaUuidJornadasRecienCreadas = this.jornadaService.getListaUuidJornadasRecienCreadas();
      this.initAllDatosWS();
    })

    this.eventService.subscribe('CANCELAR_JORNADA_SUCCESS', () => {
      this.initAllDatosWS();
    })

    this.eventService.subscribe('DESHACER_FINALIZAR_JORNADA_CONDUCTORES_EVENT', () => {
      this.initAllDatosWS();
    })

  }

  openModalCambiarSucursal() {
    this.modalService.show(CambiarSucursalComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-md'
    });
  }

  openModalCambiarSucursalCB(jornada: JornadaDTO = null) {
    this.jornadaService.setJornadaSeleccionada(jornada);
    this.modalService.show(ModalCambiarSucursalCbComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs'
    });
  }

  tienePermisoCrearJornada(): boolean {
    return this.userService.tienePermiso('JORNADA_CREAR');
  }

  tienePermisoIniciarJornada(): boolean {
    return this.userService.tienePermiso('JORNADA_INICIAR');
  }

  tienePermisoCambiarSucursalCB(): boolean {
    return this.userService.tienePermiso('JORNADA_CAMBIAR_SUCURSAL');
  }

  tienePermisoCancelarJornada(): boolean {
    return this.userService.tienePermiso('JORNADA_CANCELAR');
  }

  tienePermisoEditarJornada(): boolean {
    return this.userService.tienePermiso('JORNADA_CAMBIAR_HORA');
  }

  tienePermisoDeshacerFinJornada(): boolean {
    return this.userService.tienePermiso('CONDUCTOR_DESHACER_FIN_JORNADA');
  }

  tienePermisoImprimirPlanilla(): boolean {
    return this.userService.tienePermiso('VOUCHER_JORNADA');
  }

  crearJornada() {
    this.modalService.show(ModalCrearJornadaComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs'
    });
  }

  editarJornada(jornada: JornadaDTO = null) {
    this.jornadaService.setJornadaSeleccionada(jornada);
    this.modalService.show(ModalEditarJornadaComponent, {
      ignoreBackdropClick: true,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs'
    });
  }

  cancelarJornada(jornada: JornadaDTO = null) {
    this.jornadaService.setJornadaSeleccionada(jornada);
    this.modalService.show(ModalCancelarJornadaComponent, {
      ignoreBackdropClick: true,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs'
    });
  }

  iniciarJornada(jornada: JornadaDTO = null) {
    this.jornadaService.setJornadaSeleccionada(jornada);
    this.modalService.show(ModalIniciarJornadaComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs',
      initialState: {
        accion: 'PRE_INICIAR'
      }
    });
  }

  calcularTime() {
    clearInterval(this.intervaloProgressBar);
    if (this.recarga && this.recarga.value != 0)
      this.initProgressBar();
  }

  initProgressBar() {
    this.contador = this.recarga.value;
    this.intervaloProgressBar = setInterval(() => {
      this.contador -= 1000;
      if (this.contador < 0) {
        this.initAllDatosWS();
        this.contador = this.recarga.value;
      }

    }, 1000);
  }

  onInputConductor(e: any) {
    this.inputConductorValue.next(e.target.value);
  }

  onChangeDesde(event: any) {
    if (this.cargaInicialDatePickerDesde <= 1) {
      this.cargaInicialDatePickerDesde++;
      this.searchDesde = event;
      return;
    }

    this.searchDesde = event;
    this.page = 0;
    this.getKPISporSeccion(true);
    this.getListaJornadas(true);
  }

  onChangeHasta(event: any) {
    if (this.cargaInicialDatePickerHasta <= 1) {
      this.cargaInicialDatePickerHasta++;
      this.searchHasta = event;
      return;
    }

    this.searchHasta = event;
    this.page = 0;
    this.getKPISporSeccion(true);
    this.getListaJornadas(true);
  }

  filtrarPorKPI(kpi: KpiDTO) {
    if (this.kpiSelected && this.kpiSelected.codigo == kpi.codigo)
      this.kpiSelected = undefined;
    else
      this.kpiSelected = kpi;

    this.page = 0;
    this.estado = [];
    this.getListaJornadas(true);
  }

  changeEstadoFiltro() {
    this.page = 0;
    this.initAllDatosWS();
  }

  initAllDatosWS() {
    this.page = 0;
    this.getKPISporSeccion(true);
    this.getListaJornadas(true);
  }

  getKPISporSeccion(init: boolean = false) {
    if(this.loadingKPI)
      return;

    this.loadingKPI = true;
    let fechaDesde = '';
    let fechaHasta = '';
    if (this.searchDesde)
      fechaDesde = moment(this.searchDesde).format('YYYY-MM-DD');
    if (this.searchHasta)
      fechaHasta = moment(this.searchHasta).format('YYYY-MM-DD');

    this.apiService.getKPISporSeccion(this.sucursalService.getSucursalesUUIDSeleccionadasComoTexto(), 'GESTION_JORNADA', fechaDesde, fechaHasta)
      .subscribe((resp) => this.getKPISporSeccionSuccess(resp, init), (error) => this.getKPISporSeccionError(error));
  }

  getKPISporSeccionSuccess(getKPISgestionJornadaResponseDTO: GetKPISgestionJornadaResponseDTO, init: boolean) {
    console.log('exito kpis', getKPISgestionJornadaResponseDTO);
    this.loadingKPI = false;
    this.listaKPis = getKPISgestionJornadaResponseDTO.data;
  }

  getKPISporSeccionError(error: HttpErrorResponse) {
    console.log('error kpis', error);
    this.loadingKPI = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_KPIS_JORNADAS_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  getListaJornadas(init: boolean = false) {
    //console.log('this.loading  ', this.loading)
    if (!this.loading) {
      this.loading = true;
      let fechaDesde = '';
      let fechaHasta = '';
      if (this.searchDesde) {
        fechaDesde = moment(this.searchDesde).format('YYYY-MM-DD');
      }
      if (this.searchHasta)
        fechaHasta = moment(this.searchHasta).format('YYYY-MM-DD');

      const codigoKpi = this.kpiSelected ? this.kpiSelected.codigo : '';
      this.apiService.getListaJornadas(this.sucursalService.getSucursalesUUIDSeleccionadasComoTexto(), '', true, this.page, this.pageSize, codigoKpi, this.searchTxtConductor,
        fechaDesde, fechaHasta, this.estado.join(',')).subscribe(
          (resp) => this.getListaJornadasSuccess(resp, init),
          (error) => this.getListaJornadasError(error)
        );
    }
  }

  getListaJornadasSuccess(getListaJorndasResponseDTO: GetListaJorndasResponseDTO, init: boolean) {
    console.log('exito lista jornadas', getListaJorndasResponseDTO);
    this.loading = false;
    if (init)
      this.listaJornadas = getListaJorndasResponseDTO.data.list;
    else
      this.listaJornadas = this.listaJornadas.concat(getListaJorndasResponseDTO.data.list);

    this.hasNext = getListaJorndasResponseDTO.data.hasNext;
    this.initSuscripcionesMqtt();
    if (this.hasNext) {
      this.desactivarInfiniteScroll = false;
      this.page++;
      return;
    }

    this.desactivarInfiniteScroll = true;
  }

  getListaJornadasError(error: HttpErrorResponse) {
    console.log('error lista jornadas', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_LISTA_JORNADAS_WS;
    this.loading = false;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  initSuscripcionesMqtt() {
    console.log('init suscripicon mqtt');
    this.listaJornadas.forEach((jornada) => {
      if (!this.listadoSuscripcionesJornadasMqtt[jornada.uuid]) {
        this.listadoSuscripcionesJornadasMqtt[jornada.uuid] = this.configMqttService.subscribeTopicJornada(jornada.uuid).subscribe((mqttMessage: IMqttMessage) => {
          const json = JSON.parse(mqttMessage.payload.toString());
          //console.log('message mqtt', json.uuid); //
          const indice = this.listaJornadas.findIndex(jornada => (jornada.uuid === json.uuid) && (jornada.version < json.version));
          if (indice !== -1)
            this.getDetalleJornada(jornada.uuid);
        });
      }
    })
  }

  unsubscribeMqtt() {
    for (let uuid in this.listadoSuscripcionesJornadasMqtt) {
      if (this.listadoSuscripcionesJornadasMqtt[uuid])
        this.listadoSuscripcionesJornadasMqtt[uuid].unsubscribe();
    }
  }

  getDetalleJornada(uuid: string) {
    this.apiService.getDetalleJornada(uuid)
      .subscribe((resp) => this.getDetalleJornadaSuccess(resp), (error) => this.getDetalleJornadaError(error));
  }

  getDetalleJornadaSuccess(getDetalleJornadaResponseDTO: GetDetalleJornadaResponseDTO) {
    console.log('exito get detalle jornada', getDetalleJornadaResponseDTO);
    if (getDetalleJornadaResponseDTO.data) {
      const indice = this.listaJornadas.findIndex(jornada => jornada.uuid === getDetalleJornadaResponseDTO.data.uuid);
      if (indice !== -1) {
        //console.log('jornada encontrada y actualizada mqtt', getDetalleJornadaResponseDTO.data.uuid);
        this.listaJornadas[indice] = getDetalleJornadaResponseDTO.data;
        this.eventService.publish('JORNADA_ACTUALIZADA_MQTT_EVENT', getDetalleJornadaResponseDTO.data);
      }
    }
  }

  getDetalleJornadaError(error: HttpErrorResponse) {
    console.log('error get detalle jornada', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_DETALLE_JORNADA_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  getInicioJornadaPDF(jornada: JornadaDTO) {
    this.procesandoPdf = true;
    this.apiService.getInicioJornadaPDF(jornada.uuid)
      .subscribe((resp) => this.getInicioJornadaPDFSuccess(resp), (error) => this.getInicioJornadaPDFError(error));
  }

  getInicioJornadaPDFSuccess(pdfDTO: PdfDTO) {
    console.log('exito pdf');
    this.procesandoPdf = false;
    if (pdfDTO.base64Content)
      pdfDTO.generatePdfFromBase64();
    else
      this.toastr.success(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`, 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
    //this.alertService.presentAlertaInfo(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`);
  }

  getInicioJornadaPDFError(error: HttpErrorResponse) {
    console.log('error kpis', error);
    this.procesandoPdf = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  muestraHora(fecha: string) {
    return moment(fecha, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
  }

  muestraHorasAsignadas(minutosJornada: number) {
    const minutos = minutosJornada;
    const duration = moment.duration(minutos * 60 * 1000);
    return moment.utc(duration.asMilliseconds()).format("H[h] m[m]");
  }

  muestraTiempoRelativo(fecha: string) {
    if (!fecha)
      return '-:-';

    return moment.utc(fecha).local().calendar({
      sameDay: '[Hoy] HH:mm',
      nextDay: '[Mañana] HH:mm',
      //nextWeek: 'dddd HH:mm',
      nextWeek: 'DD MMM HH:mm',
      lastDay: '[Ayer] HH:mm',
      //lastWeek: 'dddd [pasado] HH:mm',
      lastWeek: 'DD MMM HH:mm',
      sameElse: 'DD MMM HH:mm'
    });
  }

  isConductorAtrasado(jornada: JornadaDTO) {
    const fecha2 = moment.utc(jornada.fechaInicioPlanificado);
    const fecha1 = moment().utc();
    if (fecha1 > fecha2)
      return true;
    else
      return false;
  }

  onScroll() {
    if (this.hasNext)
      this.getListaJornadas();
  }

  deshacerFinJornada(conductor) {
    this.modalService.show(ModalDeshacerFinalizarJComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs',
      initialState: {
        conductor
      }
    });
  }

  isFechaTerminoRangoValidoDeshacerFinJornada(jornada: JornadaDTO): boolean {
    if(!jornada.fechaHoraTermino || jornada.fechaHoraTermino == '')
      return false;

    const fecha2 = moment.utc(jornada.fechaHoraTermino).add(5, 'minutes');
    const fecha1 = moment().utc();
    if(fecha2.isSameOrBefore(fecha1))
      return false;

    return true;
  }

  esJornadaBloqueada(jornada: JornadaDTO): boolean {
    //CON-1050: CAPACITACION es una jornada operativa (el conductor se presenta a trabajar),
    //se puede iniciar, editar y cambiar de terminal como una planificada.
    const estadosBloqueados = ['FINALIZADA', 'LICENCIA', 'VACACIONES', 'DIA_LIBRE', 'AUSENTE', 'PERMISO'];
    if(estadosBloqueados.includes(jornada.estado))
      return true;

    if(jornada.fechaTerminoPlanficiado && moment.utc(jornada.fechaTerminoPlanficiado).local().isBefore(moment()))
      return true;

    return false;
  }

}
